import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  loadNotes,
  saveNotes,
  deleteNotes,
  clearAjaxCall
} from '../actions/Notes'

import DualRing from './DualRing'
import Error from './Error'
import AjaxSpinner from './AjaxSpinner'

import NotesDetails from './Notes/NotesDetails'
import EditNote from './Notes/EditNote'
import DeleteNote from './Notes/DeleteNote'

import { grant } from './Utils/Service'

const initialState = {
  showDelete: false,
  showEdit: false,
  note: {}
}

class Notes extends Component {
  constructor() {
    super()
    this.showDelete = this.showDelete.bind(this)
    this.showEdit = this.showEdit.bind(this)
    this.hideModal = this.hideModal.bind(this)
    this.escFunction = this.escFunction.bind(this)
    this.state = initialState
  }
  escFunction(event) {
    if (event.keyCode === 27) {
      this.hideModal()
    }
  }
  componentWillMount() {
    if (this.props.notes.list === null) {
      this.reloadNotes()
    }
  }
  showDelete(note) {
    this.setState({ showDelete: true, note })
  }
  showEdit(note) {
    this.setState({ showEdit: true, note })
  }
  newNote() {
    this.setState({
      showEdit: true,
      note: {
        id: null,
        title: '',
        message: '',
        share: 0
      }
    })
  }
  hideModal() {
    this.setState({
      showDelete: false,
      showEdit: false
    })
  }
  reloadNotes() {
    this.props.loadNotes()
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.notes.ajaxSpinner &&
      !this.props.notes.ajaxSpinner &&
      this.props.notes.ajaxStatus === null
    ) {
      this.hideModal()
    }
    if (
      prevProps.notes.ajaxSpinner &&
      !this.props.notes.ajaxSpinner &&
      this.props.notes.ajaxStatus !== null
    ) {
      setTimeout(() => {
        this.props.clearAjaxCall('')
      }, 3000)
    }
  }
  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false)
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false)
  }
  render() {
    const { list, error, loading, ajaxSpinner } = this.props.notes
    return (
      <div>
        <div className='page-header'>
          <div className='ph-title'>Note</div>
          <div className='ph-descr txt'>
            Le note possono essere private o condivise con gli altri membri
            della tua associazione
          </div>
          <ul className='ph-btn'>
            {grant() && (
              <li>
                <button onClick={() => this.newNote()} className='lnk-tools'>
                  <i className='fas fa-sticky-note'></i> aggiungi
                </button>
              </li>
            )}
            <li>
              <button onClick={() => this.reloadNotes()} className='lnk-tools'>
                <i className='fas fa-redo-alt'></i> ricarica
              </button>
            </li>
          </ul>
          <div className='ph-count'>
            {list !== null &&
              list.length + (list.length === 1 ? ' risultato' : ' risultati')}
            {list === null && <i className='fas fa-sync fa-spin'></i>}
          </div>
        </div>
        {loading && <DualRing />}
        {error && <Error error={error} />}
        {list !== null &&
          list.map((n, index) => {
            return (
              <NotesDetails
                key={index}
                note={n}
                showDelete={this.showDelete}
                showEdit={this.showEdit}
              />
            )
          })}
        {this.state.showEdit && (
          <EditNote note={this.state.note} hideModal={this.hideModal} />
        )}
        {this.state.showDelete && (
          <DeleteNote note={this.state.note} hideModal={this.hideModal} />
        )}
        {ajaxSpinner && <AjaxSpinner />}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {
  loadNotes,
  saveNotes,
  deleteNotes,
  clearAjaxCall
})(Notes)



// WEBPACK FOOTER //
// ./src/components/Notes.js